import { G2Badge } from '@/components/integrations/g2';
import { ProxywayBadge } from '@/components/integrations/proxyway';
import { TrustpilotBadge } from '@/components/integrations/trustpilot';

import { Divider } from '@/decodo/components/atoms/Divider';
import AnimatedEl from '@/lib/motion';
import { cn } from '@/lib/utils';

export function ReputationBadges({
  classNames,
  delayFactor,
}: {
  classNames?: { root?: string };
  delayFactor?: number;
}) {
  return (
    <AnimatedEl
      el='div'
      className={cn('flex gap-3', classNames?.root)}
      transition={{
        delayChildren: delayFactor
          ? Math.max(delayFactor * 3, 0.75)
          : delayFactor,
      }}
      variants={{}}
    >
      <AnimatedEl el='div' variants={badgeVariants}>
        <TrustpilotBadge />
      </AnimatedEl>
      <AnimatedEl el='div' variants={dividerVariants}>
        <Divider
          showOnDark
          alignment='vertical'
          classNames={{ root: 'border-gray-200' }}
        />
      </AnimatedEl>
      <AnimatedEl el='div' variants={badgeVariants}>
        <G2Badge />
      </AnimatedEl>
      <AnimatedEl el='div' variants={dividerVariants}>
        <Divider
          showOnDark
          alignment='vertical'
          classNames={{ root: 'border-gray-200' }}
        />
      </AnimatedEl>
      <AnimatedEl el='div' variants={badgeVariants}>
        <ProxywayBadge />
      </AnimatedEl>
    </AnimatedEl>
  );
}

const badgeVariants = {
  initial: { opacity: 0, y: -8 },
  animate: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const dividerVariants = {
  initial: { scaleY: 0 },
  animate: { scaleY: 1 },
};
